import { Utils } from 'cc-common';
import { Exclude, Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';

export class BoardApprovalParameterDto {
    processId: string;
    responseToOwner: string;
    notes: string;

    // Transient
    @Exclude()
    description: string;

    @Exclude()
    processIdDisplayText: string;

    @Exclude()
    @Type(() => UserNameDisplayResultDto)
    userInfo: UserNameDisplayResultDto;

    @Exclude()
    get userNameDisplayText(): string {
        return Utils.notNullAndDefined(this.userInfo) ? this.userInfo.displayName : null;
    }
}
